// file: src/utilies/loader/LoadGeojsonImage.js

// Small, focused deps from your codebase
import { createUniqueId } from "../Utility"; // adjust path if needed
import Type from "../Types"; // adjust path if needed
import { loadGeojsonPointsOptimized } from "../CameraImagesUtility"; // adjust path if needed

/**
 * Load a GEOJSON (camera images) into Cesium + state.
 * Pass required setters and refs so nothing breaks.
 */
export const loadGeojsonImageType = ({
  // required context (all from your StateContext or refs)
  viewerRef,
  setImageGeojson,
  setImageGeojsonSelected,
  setImageGeojsonMode,
  setImageDataSource,
  setMapObjects,
  setImageGeojsonCounter,
  geojsonData,
  fileName,
  layerId,
  projectId,
}) => {
  // clone for safe attach into mapObjects
  const dataClone = JSON.parse(JSON.stringify(geojsonData));

  // sort images by camera_type
  if (Array.isArray(geojsonData.features)) {
    geojsonData.features.forEach((feature) => {
      const imgs = feature?.properties?.images;
      if (Array.isArray(imgs)) {
        imgs.sort((a, b) => {
          if (a.camera_type < b.camera_type) return -1;
          if (a.camera_type > b.camera_type) return 1;
          return 0;
        });
      }
    });
  }

  // prefix relpath with "camera/"
  geojsonData.features.forEach((feature) => {
    const imgs = feature?.properties?.images;
    if (Array.isArray(imgs)) {
      imgs.forEach((image) => {
        if (image?.relpath) image.relpath = "camera/" + image.relpath;
      });
    }
  });

  // set global image state
  setImageGeojson(geojsonData);
  if (geojsonData.features?.length > 0) {
    setImageGeojsonSelected(geojsonData.features[0]);
  }
  setImageGeojsonMode(true);

  // add points into Cesium, wire selection callback
  const ds = loadGeojsonPointsOptimized(viewerRef.current, geojsonData, fileName, (feature, index) => {
    // keep selected feature in sync
    setImageGeojsonSelected(feature);
    setImageGeojsonCounter(index);
  });

  setImageDataSource(ds);

  // register in mapObjects
  setMapObjects((prev) => [
    ...prev,
    {
      id: createUniqueId(),
      name: "Camera Image",
      type: Type.ASSET.GEOJSON_IMAGE,
      file_name: fileName,
      file_type: ".geojson",
      inner_entities: [],
      visible: true,
      dataSource: ds,
      arrow_visibility: false,
      route_visibility: false,
      geojson: dataClone, // keep a clean copy
      layer_id: layerId ? layerId : null,
      project_id: projectId ? projectId : null,
    },
  ]);

  // return created datasource in case caller needs it
  return ds;
};
